var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.storedTodoItems.length)?_c('div',{staticClass:"clear-all-container"},[_c('span',{staticClass:"clear-all-container__btn",on:{"click":_vm.clearTodo}},[_vm._v("Clear All")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }